import {
    ESSENTIAL,
    ExtraFeatureT,
} from 'routes/Support/components/ClientSupport/components/ClientConfiguration/ModuleForm/helpers/definitions';
import { ModuleT, SUPPORT } from 'business/constants';
import { useSelector } from 'store/hooks';
import { DECISION_USER, EXPLORE_USER } from '../business/constants';
import { UserRole } from '../business/definitions';

export const useClientHasModule = (module: ModuleT) =>
    useSelector((state) => state.vision.client.modules?.includes(module));

const useClientHasExtraFeatures = (extraFeature: ExtraFeatureT) =>
    useSelector((state) =>
        state.vision.client.extraFeatures?.includes(extraFeature),
    );

export const useUserHasRole = (role: UserRole) =>
    useSelector((state) => state.vision.user.roles.includes(role));

export const useIsExploreUser = () => {
    const roles: UserRole[] = [DECISION_USER, EXPLORE_USER];
    const isSupport = useUserHasRole(SUPPORT);
    return (
        useSelector((state) =>
            roles.every((r) => state.vision.user.roles.includes(r)),
        ) || isSupport
    );
};

export const useIsEssential = () => useClientHasExtraFeatures(ESSENTIAL);
